export enum TeacherLicenseAccess {
  NeedsAvailableLicensesAssigned = 'NeedsAvailableLicensesAssigned',
  RouteToCurrentClassroom = 'RouteToCurrentClassroom',
  RouteToProducts = 'RouteToProducts',
  RouteToFirstClassroom = 'RouteToFirstClassroom',
  RouteToClassrooms = 'RouteToClassrooms',
  RouteToNewClass = 'RouteToNewClass',
}
